// Sloučení načtených zpráv konverzace.
//
// První stránka obsahuje nejnovější zprávy. Když se konverzace otevře
// znovu, načte se znovu a nesmí přepsat starší stránky, které jsme si
// už dohledali při hledání – jinak by hledaná zpráva zase zmizela
// a scroll by skočil jinam.
export const mergeLoadedMessages = (existing = [], incoming = [], page = 1) => {
  if (page !== 1) {
    // Starší stránku přidáváme před už načtené zprávy. Filtrujeme zprávy,
    // které už v seznamu jsou – po znovunačtení první stránky se meta
    // vrátí na 1 a klient si stránku vyžádá znovu. Bez filtru by se
    // v seznamu objevily dvakrát.
    const existingIds = new Set(existing.map((item) => item.id));
    const fresh = incoming.filter((item) => !existingIds.has(item.id));

    return [...fresh, ...existing].sort((a, b) => a.id - b.id);
  }

  if (existing.length === 0) return [...incoming];

  const incomingIds = new Set(incoming.map((message) => message.id));
  const newestIncomingId = incoming.reduce(
    (max, message) => Math.max(max, message.id),
    0,
  );

  // Starší zpráva je jen ta, která je menší než všechny z první stránky.
  // Zprávy na první stránce vždy přebírají ty uložené – při novém
  // načtení je chceme čerstvé.
  const older = existing.filter(
    (message) => !incomingIds.has(message.id) && message.id < newestIncomingId,
  );

  return [...older, ...incoming].sort((a, b) => a.id - b.id);
};

export default mergeLoadedMessages;
